"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncHash = void 0;
async function asyncHash(obj) {
    const keys = Object.keys(obj);
    const list = await Promise.all(keys.map((key) => obj[key]));
    return list.reduce((hashOfResolved, value, i) => {
        hashOfResolved[keys[i]] = value;
        return hashOfResolved;
    }, {});
}
exports.asyncHash = asyncHash;
//# sourceMappingURL=AsyncUtils.js.map